module.exports = __webpack_public_path__ + "static/media/research_2.1072d784.png";